import { LinearProgress, Stack, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { useGetTitrationQuery } from "src/api/services/titrationApi";
import { MatchParam } from "src/constants/matches";
import MedicationTitrations from "../MedicationTitrations";

const TitrationDetails = () => {
  const { titrationId } = useParams<MatchParam<"TITRATION_ID">>();

  const { data, isLoading } = useGetTitrationQuery(
    titrationId != null ? Number(titrationId) : skipToken,
  );

  if (isLoading) {
    return <LinearProgress />;
  }

  if (data == null) {
    return (
      <Typography>
        Looks like this titration schedule is missing some vital information
      </Typography>
    );
  }

  return (
    <Stack gap={2}>
      <Stack gap={1}>
        <Typography variant="h4" fontWeight={600}>
          {`${data.product.name} - Tier ${data.tier}`}
        </Typography>
        <Typography variant="h5">
          {`Total dose: ${data.total_dose} ${data.dose_unit}`}
        </Typography>
        <Typography variant="h5">
          {`Dose range: ${data.min_dose}-${data.max_dose} ${data.dose_unit}`}
        </Typography>
        <Typography variant="h5">
          {`Duration: ${data.duration_in_months} month(s)`}
        </Typography>
        <Typography variant="h5">
          {`Price: ${data.price?.amount != null ? `$${data.price?.amount}` : "Subscription based"}`}
        </Typography>
      </Stack>
      <MedicationTitrations titrationId={data.id} />
    </Stack>
  );
};

export default TitrationDetails;
